import { useContext, useEffect, useState } from "react";
import { formatDateToDDMMAAAA } from "../../../../../functions/kit-mdtw/dates";
import SendIcon from "@mui/icons-material/Send";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import CircularProgress from "@mui/material/CircularProgress";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ICandidatoSolEnviada } from "../../../../../interfaces/ISeleccion";
import ActionMassive from "./ActionMassive";
import FooterTablePagination from "../../../../ui/kit-mdtw/table/FooterTablePagination";
import Tooltip from "../../../../ui/kit-mdtw/tooltip/Tooltip";
import TableSkeleton from "../../../../ui/kit-mdtw/table/TableSkeleton";
import { AnimatePresence } from "framer-motion";
import ModalVerSolicitud from "./ModalVerSolicitud";

const TablaSolicitudEnviada = () => {
  const {
    token,
    getToken,
    listaCandidatoSolEnviada,
    getCandidatoPreSolEnviada,
    getDetalleSolicitudTraspaso,
  } = useContext(SeleccionContext);
  const [isLoadingTable, setIsLoadingTable] = useState<boolean | undefined>(
    undefined
  );
  const [isErrorTable, setIsErrorTable] = useState<boolean | undefined>(
    undefined
  );
  const [gridCandidatoSolEnviada, setGridCandidatoSolEnviada] = useState<any[]>(
    []
  );
  const [offset, setOffset] = useState<any>({
    offset: { value: undefined, valid: true },
    pages: 1,
  });
  const [paginationData, setPaginationData] = useState<any>({});
  const [localStorageFilter] = useState<string>("filtroCandidatoSolEnviada");
  const [openModalVerSolicitud, setOpenModalVerSolicitud] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [detalleData, setDetalleData] = useState<any>(null);
  const [loadingVerSolicitud, setLoadingVerSolicitud] = useState<string | null>(null);
  const [formFilter, setFormFilter] = useState<any>({
    estado: [],
    nombre: [],
    rut: [],
    proceso: [],
    procesoDestino: [],
    reclutador: [],
    fechaSolicitud: [],
  });

  useEffect(() => {
    if (token) {
      if (localStorage.getItem(localStorageFilter)) {
        const copyStorage: any = localStorage.getItem(localStorageFilter);
        getCandidatoPreSolEnviada({
          token,
          filtros: JSON.parse(copyStorage),
          setIsErrorTable,
          setIsLoadingTable,
          setPaginationData,
          page: offset.pages ?? 1,
          limit: offset.offset.value?.code ?? 10,
        });
      } else {
        getCandidatoPreSolEnviada({
          token,
          filtros: formFilter,
          setIsErrorTable,
          setIsLoadingTable,
          setPaginationData,
          page: offset.pages ?? 1,
          limit: offset.offset.value?.code ?? 10,
        });
      }
    }
  }, [token, localStorage.getItem(localStorageFilter), offset.pages, offset.offset]);

  useEffect(() => {
    if (listaCandidatoSolEnviada) {
      setGridCandidatoSolEnviada([...listaCandidatoSolEnviada]);
    }
  }, [listaCandidatoSolEnviada]);

  const handleClickVerSolicitud = async (rowData: any): Promise<void> => {
    const { solicitudTraspasoId } = rowData;
    setSelectedRow(rowData);
    setLoadingVerSolicitud(solicitudTraspasoId);
    const data = await getDetalleSolicitudTraspaso({
      token,
      transferRequestId: solicitudTraspasoId,
      setIsLoading: (val: boolean) => {
        if (!val) setLoadingVerSolicitud(null);
      },
    });
    if (data) {
      setDetalleData(data);
      setOpenModalVerSolicitud(true);
    }
  };

  return (
    <>
      <section className="content-seleccion-multiple action-in-line margin-top-20">
        <div className="content-multiple" />
        <ActionMassive
          listadoSeleccionado={[]}
          localStorageFilter={localStorageFilter}
          formFilter={formFilter}
          setFormFilter={setFormFilter}
        />
      </section>

      <section className="content-header-table" style={{ justifyContent: "center" }}>
        <label className="title-header-table" style={{ textTransform: "uppercase", gap: "8px" }}>
          <SendIcon sx={{ fontSize: 18 }} />
          Solicitudes enviadas
        </label>
      </section>

      {!isLoadingTable ? (
        <>
          {isErrorTable ? (
            <div className="container-is-error-table">
              Error al cargar los datos.
            </div>
          ) : (
            <>
              <main className="container-table-list traspaso-table-container">
                <table className="content-table traspaso-table-enviada">
                  <thead className="thead-table-registros">
                    <tr>
                      <th className="th-table-registros">Nombre</th>
                      <th className="th-table-registros col-w-rut">Rut</th>
                      <th className="th-table-registros">ID Origen</th>
                      <th className="th-table-registros">ID Destino</th>
                      <th className="th-table-registros">Reclutador</th>
                      <th className="th-table-registros col-w-fecha">Fecha Solicitud</th>
                      <th className="th-table-registros">Estado</th>
                      <th className="th-table-registros col-w-acciones">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-table-registros">
                    {gridCandidatoSolEnviada &&
                      gridCandidatoSolEnviada.map(
                        (item: ICandidatoSolEnviada) => {
                          const {
                            personaDNI,
                            estado,
                            primerNombre,
                            primerApellido,
                            procesoOrigen,
                            procesoDestino,
                            fechaSolicitud,
                            propietario,
                          } = item;
                          return (
                            <>
                              <tr
                                key={personaDNI}
                                className={`tr-table-registros${estado === "APROBADA" ? " estado-aprobada" : estado === "RECHAZADA" ? " estado-rechazada" : ""}`}
                                style={{
                                  backgroundColor:
                                    estado === "APROBADA"
                                      ? "#DCFCE7"
                                      : estado === "RECHAZADA"
                                      ? "#FFF1F2"
                                      : undefined,
                                }}
                                onMouseEnter={(e) => {
                                  if (estado === "APROBADA")
                                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#BBF7D0";
                                  else if (estado === "RECHAZADA")
                                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#FFE4E6";
                                }}
                                onMouseLeave={(e) => {
                                  if (estado === "APROBADA")
                                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#DCFCE7";
                                  else if (estado === "RECHAZADA")
                                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#FFF1F2";
                                }}
                              >
                                <td className="td-table-registros" data-label="Nombre">
                                  {primerNombre} {primerApellido}
                                </td>
                                <td className="td-table-registros col-w-rut" data-label="Rut">
                                  {personaDNI}
                                </td>
                                <td className="td-table-registros" data-label="ID Origen">
                                  {procesoOrigen}
                                </td>
                                <td className="td-table-registros" data-label="ID Destino">
                                  <span style={{
                                    display: "inline-block",
                                    backgroundColor: "#DBEAFE",
                                    color: "#1D4ED8",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    padding: "2px 8px",
                                    borderRadius: "6px",
                                    border: "1px solid #93C5FD",
                                  }}>
                                    {procesoDestino}
                                  </span>
                                </td>
                                <td className="td-table-registros" data-label="Reclutador">
                                  {propietario}
                                </td>
                                <td className="td-table-registros col-w-fecha" data-label="Fecha">
                                  {formatDateToDDMMAAAA({
                                    date: fechaSolicitud,
                                    format: "/",
                                  })}
                                </td>
                                <td className="td-table-registros" data-label="Estado">
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "6px",
                                      width: "110px",
                                      padding: "5px 0",
                                      borderRadius: "20px",
                                      fontSize: "11px",
                                      fontWeight: 700,
                                      letterSpacing: "0.5px",
                                      textTransform: "uppercase",
                                      backgroundColor:
                                        estado === "ENVIADA"
                                          ? "#DBEAFE"
                                          : estado === "APROBADA"
                                          ? "#DCFCE7"
                                          : estado === "RECHAZADA"
                                          ? "#FFE4E6"
                                          : "#F3F4F6",
                                      color:
                                        estado === "ENVIADA"
                                          ? "#1D4ED8"
                                          : estado === "APROBADA"
                                          ? "#15803D"
                                          : estado === "RECHAZADA"
                                          ? "#BE123C"
                                          : "#6B7280",
                                      border: "1px solid",
                                      borderColor:
                                        estado === "ENVIADA"
                                          ? "#93C5FD"
                                          : estado === "APROBADA"
                                          ? "#86EFAC"
                                          : estado === "RECHAZADA"
                                          ? "#FCA5A5"
                                          : "#D1D5DB",
                                    }}
                                  >
                                    {estado === "ENVIADA" && (
                                      <SendIcon sx={{ fontSize: 11 }} />
                                    )}
                                    {estado === "APROBADA" && (
                                      <TaskAltIcon sx={{ fontSize: 12 }} />
                                    )}
                                    {estado === "RECHAZADA" && (
                                      <CancelIcon sx={{ fontSize: 12 }} />
                                    )}
                                    {estado}
                                  </span>
                                </td>
                                <td className="td-table-registros col-w-acciones">
                                  <section className="content-icon-table">
                                    <Tooltip text="Ver solicitud">
                                      <button
                                        onClick={() => handleClickVerSolicitud(item)}
                                        className="button-content"
                                        disabled={loadingVerSolicitud === item.solicitudTraspasoId}
                                      >
                                        {loadingVerSolicitud === item.solicitudTraspasoId ? (
                                          <CircularProgress size={18} thickness={4} sx={{ color: "#0065DD" }} />
                                        ) : (
                                          <VisibilityIcon sx={{ fontSize: 20, color: "#0065DD" }} />
                                        )}
                                      </button>
                                    </Tooltip>
                                  </section>
                                </td>
                              </tr>
                            </>
                          );
                        }
                      )}
                  </tbody>
                </table>
              </main>

              {/* Tarjetas mobile */}
              <div className="traspaso-cards-mobile">
                {gridCandidatoSolEnviada && gridCandidatoSolEnviada.map((item: ICandidatoSolEnviada) => {
                  const { personaDNI, estado, primerNombre, primerApellido, procesoOrigen, procesoDestino, fechaSolicitud, propietario, solicitudTraspasoId } = item as any;
                  return (
                    <div
                      key={solicitudTraspasoId}
                      className={`traspaso-card${estado === "APROBADA" ? " estado-aprobada" : estado === "RECHAZADA" ? " estado-rechazada" : ""}`}
                    >
                      <div className="traspaso-card-header">
                        <span className="traspaso-card-name">{primerNombre} {primerApellido}</span>
                        <span style={{
                          display: "inline-flex", alignItems: "center", gap: "5px",
                          padding: "3px 10px", borderRadius: "20px", fontSize: "10px",
                          fontWeight: 700, letterSpacing: "0.5px", textTransform: "uppercase" as const,
                          whiteSpace: "nowrap" as const,
                          backgroundColor: estado === "ENVIADA" ? "#DBEAFE" : estado === "APROBADA" ? "#DCFCE7" : estado === "RECHAZADA" ? "#FFE4E6" : "#F3F4F6",
                          color: estado === "ENVIADA" ? "#1D4ED8" : estado === "APROBADA" ? "#15803D" : estado === "RECHAZADA" ? "#BE123C" : "#6B7280",
                          border: "1px solid",
                          borderColor: estado === "ENVIADA" ? "#93C5FD" : estado === "APROBADA" ? "#86EFAC" : estado === "RECHAZADA" ? "#FCA5A5" : "#D1D5DB",
                        }}>
                          {estado === "ENVIADA" && <SendIcon sx={{ fontSize: 10 }} />}
                          {estado === "APROBADA" && <TaskAltIcon sx={{ fontSize: 10 }} />}
                          {estado === "RECHAZADA" && <CancelIcon sx={{ fontSize: 10 }} />}
                          {estado}
                        </span>
                      </div>
                      <div className="traspaso-card-body">
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">RUT</span>
                          <span className="traspaso-card-value">{personaDNI}</span>
                        </div>
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">ID Origen</span>
                          <span className="traspaso-card-value">{procesoOrigen}</span>
                        </div>
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">ID Destino</span>
                          <span style={{ backgroundColor: "#DBEAFE", color: "#1D4ED8", fontWeight: 700, fontSize: "12px", padding: "2px 8px", borderRadius: "6px", border: "1px solid #93C5FD" }}>
                            {procesoDestino}
                          </span>
                        </div>
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">Reclutador</span>
                          <span className="traspaso-card-value">{propietario}</span>
                        </div>
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">Fecha</span>
                          <span className="traspaso-card-value">{formatDateToDDMMAAAA({ date: fechaSolicitud, format: "/" })}</span>
                        </div>
                      </div>
                      <div className="traspaso-card-footer">
                        <button
                          onClick={() => handleClickVerSolicitud(item)}
                          className="button-content"
                          disabled={loadingVerSolicitud === solicitudTraspasoId}
                        >
                          {loadingVerSolicitud === solicitudTraspasoId ? (
                            <CircularProgress size={18} thickness={4} sx={{ color: "#0065DD" }} />
                          ) : (
                            <VisibilityIcon sx={{ fontSize: 20, color: "#0065DD" }} />
                          )}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>

              <FooterTablePagination
                offset={offset}
                setOffset={setOffset}
                paginationData={paginationData}
              />
            </>
          )}
        </>
      ) : (
        <TableSkeleton cols={8} />
      )}

      <AnimatePresence>
        {openModalVerSolicitud && detalleData && (
          <ModalVerSolicitud
            detalleData={detalleData}
            onClose={() => { setOpenModalVerSolicitud(false); setDetalleData(null); }}
          />
        )}
      </AnimatePresence>

    </>
  );
};

export default TablaSolicitudEnviada;
